import { BottomSummaryBarV2, SummaryColumn } from '@/components/custom/erp';

interface BottomBarProps {
  tongSoLuong?: number;
  tongTien?: number;
  tongChiPhi?: number;
  tongThue?: number;
  tongThanhToan?: number;
}

export function BottomBar({
  tongSoLuong = 0,
  tongTien = 0,
  tongChiPhi = 0,
  tongThue = 0,
  tongThanhToan = 0
}: BottomBarProps) {
  const columns: SummaryColumn[] = [
    {
      fields: [{ name: 't_so_luong', label: 'Tổng số lượng', value: tongSoLuong, precision: 6 }]
    },
    {
      fields: [
        { name: 't_tien_nt', label: 'Tổng tiền', value: tongTien },
        { name: 't_cp_nt', label: 'Tổng chi phí', value: tongChiPhi }
      ],
      className: 'min-w-[300px]'
    },
    {
      fields: [
        { name: 't_thue_nt', label: 'Tổng thuế', value: tongThue, labelClassName: 'w-32' },
        { name: 't_tt_nt', label: 'Tổng thanh toán', value: tongThanhToan, labelClassName: 'w-32' }
      ],
      className: 'ml-auto min-w-[320px]'
    }
  ];

  return (
    <>
      <BottomSummaryBarV2 columns={columns} />
      <input type='hidden' name='t_tien' value={tongTien} />
      <input type='hidden' name='t_cp' value={tongChiPhi} />
      <input type='hidden' name='t_thue' value={tongThue} />
      <input type='hidden' name='t_tt' value={tongThanhToan} />
    </>
  );
}

export default BottomBar;
